import Vue from "vue";
import vuex from "vuex";
Vue.use(vuex);

export default new vuex.Store({
  state: {
    currentServerInfo: {},
 // 当前访问服务器信息

    navBarActive: {},

    defaultActive: "1",
    eUserInfo: "",
    authSuccessShowTab: "",
    currentLevelMap: "country", // country,province,city,area,company
    currentLocationMap: "广东",

    useTrendType: null,
    eMeterUseTrendType: null,
    eMeterWatchDateRange: null,
    buildingID: null,
    eMeterID: null,
    allBuildingDevice: "",
    topUseDateRange: null,
    buildingWatchDateRange: null,
    buildingWatchPerPage: null,

    spaceID: [], //空间ID

    isfunMap: false, //是否有仪表盘权限（即现在的数据控制中心）

    itemH: 0, //电表空间耗电量高度

    htmlFontSize: "", // html的font-size
    isOnresize: false // 屏幕是否变化
  },

  mutations: {
    // 当前访问服务器信息
    currentServerInfo(state, value) {
      state.currentServerInfo = value;
    },

    // 已选导航栏
    navBarActive(state, value) {
      state.navBarActive = value;
    },

    // 默认上次选择二级菜单
    defaultActive(state, value) {
      state.defaultActive = value;
    },

    // 登录成功后返回信息，token，显示页面等
    eUserInfo: function(state, value) {
      state.eUserInfo = value;
    },

    // 用户管理 - 组织管理 - 角色权限分配成功后，返回组织管理显示tab
    authSuccessShowTab: function(state, value) {
      state.userInfo = value;
    },

    // 地图
    saveCurrentLevelMap(state, value) {
      state.currentLevelMap = value;
    },

    saveCurrentLocationMap(state, value) {
      state.currentLocationMap = value;
    },


    //以下是能耗模块的
    saveUseTrendType(state, value) {
      state.useTrendType = value;
    },

    saveEMeterUseTrendType(state, value) {
      state.eMeterUseTrendType = value;
    },

    saveEMeterWatchDateRange(state, value) {
      state.eMeterWatchDateRange = value;
    },

    saveBuildingID(state, value) {
      state.buildingID = value;
    },

    saveEMeterID(state, value) {
      state.eMeterID = value;
    },

    saveAllBuildingDevice(state, value) {
      state.allBuildingDevice = value;
    },

    saveTopUseDateRange(state, value) {
      state.topUseDateRange = value;
    },

    saveBuildingWatchDateRange(state, value) {
      state.buildingWatchDateRange = value;
    },

    saveBuildingWatchPerPage(state, value) {
      state.buildingWatchPerPage = value;
    },


    spaceID(state, value) {
      state.spaceID = value;
    },


    itemH(state, value) {
      state.itemH = value;
    },


    // 以下数据看板模块
    // html的font-size
    htmlFontSize(state, value) {
      state.htmlFontSize = value;
    },

    // 屏幕是否变化
    isOnresize(state, value) {
      state.isOnresize = value;
    },

    initMenu(state, menu) {
      state.routes = menu
    }
  }
});



// WEBPACK FOOTER //
// ./src/store/index.js